import { motion } from "framer-motion";
import { useGlobalStats } from "@/hooks/useGlobalStats";
import { MintController } from "@/components/operations/MintController";
import { TrendingUp } from "lucide-react";

export function HeroSection() {
  const { stats } = useGlobalStats();

  return (
    <section className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="absolute inset-0 -z-10 opacity-30">
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `radial-gradient(circle at 70% 30%, rgba(34,197,94,0.12), transparent 40%), radial-gradient(circle at 30% 70%, rgba(240,185,11,0.08), transparent 40%)`,
          }}
        />
      </div>

      <div className="container mx-auto max-w-6xl px-4">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[var(--accent-green)]/30 bg-[var(--accent-green)]/10 px-3 py-1">
              <TrendingUp size={14} className="text-[var(--accent-green)]" />
              <span className="text-xs font-semibold uppercase tracking-wider text-[var(--accent-green)]">
                1,024 on Robinhood Chain
              </span>
            </div>

            <h1 className="font-pixel text-4xl leading-[1.1] text-foreground md:text-6xl">
              CAT CLAW
              <br />
              <span className="text-gradient-green">EVERY HOUR</span>
            </h1>

            <p className="mt-5 max-w-lg text-base text-muted-foreground md:text-lg">
              Burn $CATCLAW to activate your cat, pick your stock split, and earn
              NVDA + SPCX + SPY rewards every hour. The market never closes.
            </p>

            <div className="mt-8 max-w-md">
              <MintController />
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
              <div className="rounded-lg border border-border bg-card px-3 py-2">
                <span className="font-pixel text-[10px] text-primary">SUPPLY</span>
                <span className="ml-2 font-mono">{stats.totalSupply} / {stats.maxSupply}</span>
              </div>
              <div className="rounded-lg border border-border bg-card px-3 py-2">
                <span className="font-pixel text-[10px] text-primary">PRICE</span>
                <span className="ml-2 font-mono">{stats.mintPriceEth} ETH</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative flex justify-center"
          >
            <div className="relative">
              <div className="absolute -inset-4 -z-10 rounded-full bg-[var(--accent-green)]/20 blur-3xl" />
              <img
                src="/brand/cover.png"
                alt="Cat Claw cover"
                className="relative z-10 max-h-[420px] rounded-3xl border border-border bg-card shadow-2xl md:max-h-[520px]"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
